import { render, staticRenderFns } from "./AcceptText.vue?vue&type=template&id=dca68212&scoped=true&lang=html&"
import script from "./AcceptText.vue?vue&type=script&lang=js&"
export * from "./AcceptText.vue?vue&type=script&lang=js&"
import style0 from "./AcceptText.vue?vue&type=style&index=0&id=dca68212&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dca68212",
  null
  
)

export default component.exports